import React, { useState, useEffect } from 'react';
import JobDetailsModal from './JobDetailsModal';
import mockJobData from '../data/mockJob.json';

interface JobCardProps {
  job: {
    title: string;
    status: string;
    locations: {
      city: string;
      region: string;
      country: string;
    }[];
    companyName: string;
  };
  isMobile: boolean;
}

const JobCard: React.FC<JobCardProps> = ({ job, isMobile }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fullJobDetails, setFullJobDetails] = useState<any>(null);

  useEffect(() => {
    // In a real app, you might fetch this data based on job ID
    // For now, we'll use the mock data
    // setFullJobDetails(mockJobData);
    setFullJobDetails(job);
  }, []);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <div
        onClick={openModal}
        style={{
          backgroundColor: 'white',
          borderRadius: '6px',
          border: '2px solid #e0e4e8',
          padding: isMobile ? '0.75rem' : '1rem',
          marginBottom: '1rem',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: isMobile ? 'flex-start' : 'space-between',
          alignItems: 'flex-start',
          gap: '0.5rem',
          cursor: 'pointer', // Add cursor pointer to indicate clickable
          textAlign: 'left'
        }}
        id="job-card"
      >
        {/* Mobile view: Title and Badge on same line */}
        {isMobile ? (
          <>
            <h3
              style={{
                margin: '0',
                fontWeight: '600',
                color: '#333',
                fontSize: '1.1rem',
                marginTop: '0.5rem',
                textAlign: 'left'
              }}
            >
              {job.title}
            </h3>
            {/* <span
              style={{
                color: '#184673',
                backgroundColor: '#eaf3fc',
                padding: '0.3rem 0.75rem',
                borderRadius: '8px',
                fontSize: '0.85rem',
                fontWeight: '500',
                textAlign: 'left'
              }}
            >
              {job.status}
            </span> */}
            <p
              style={{
                margin: '0',
                color: '#6c757d',
                fontSize: '0.85rem',
                textAlign: 'left'
              }}
            >
              {job.locations && job.locations.length > 0
                ? `${job.locations[0].city}, ${job.locations[0].region}, ${job.locations[0].country}`
                : 'Location not specified'}
            </p>
            <p style={{fontWeight: 500, margin: 0, padding: 0}}>
              {job.companyName}
            </p>
            <p
                style={{
                color: '#0066cc', // Hyperlink blue color
                textDecoration: 'underline',
                cursor: 'pointer',
                margin: '0',
                fontSize: '0.9rem',
                }}
              >
                Show more
              </p>
          </>
        ) : (
          // Desktop view: Original layout
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              textAlign: 'left'
            }}
          >
            <div style={{ textAlign: 'left' }}>
              <h3
                style={{
                  margin: '0 0 0.25rem 0',
                  fontWeight: '600',
                  color: '#333',
                  fontSize: '1.25rem',
                  textAlign: 'left'
                }}
              >
                {job.title}
              </h3>
              <p
                style={{
                  margin: '0',
                  color: '#6c757d',
                  fontSize: '0.9rem',
                  textAlign: 'left'
                }}
              >
                {job.locations && job.locations.length > 0
                  ? `${job.locations[0].city}, ${job.locations[0].region}, ${job.locations[0].country}`
                  : 'Location not specified'}
              </p>
              <p style={{fontWeight: 500, marginTop: '0.3rem', marginBottom: '0.3rem'}}>
                {job.companyName}
              </p>
              <p
                style={{
                  marginTop: '0.5rem',
                  color: '#0066cc', // Hyperlink blue color
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  margin: '0',
                  fontSize: '0.9rem'
                }}
              >
                Show more
              </p>
            </div>
            {/* <span
              style={{
                color: '#184673',
                backgroundColor: '#eaf3fc',
                padding: '0.3rem 0.75rem',
                marginBottom: '1.1rem',
                borderRadius: '8px',
                fontSize: '0.85rem',
                fontWeight: '500'
              }}
            >
              {job.status}
            </span> */}
          </div>
        )}
      </div>

      {fullJobDetails && (
        <JobDetailsModal
          isOpen={isModalOpen}
          onClose={closeModal}
          job={{
            ...job,
            ...fullJobDetails,
          }}
        />
      )}
    </>
  );
};

export default JobCard;
